module.exports = __webpack_public_path__ + "static/media/add emergency maintenance.7e1ce71f.svg";